// Botões da tela "Meu plano": raio 10px, altura 40px, sem caixa alta

const base = {
  height: 40,
  px: 2.25,
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.875rem',
  boxShadow: 'none',
  whiteSpace: 'nowrap',
};

export const primaryButtonSx = {
  ...base,
  backgroundColor: 'var(--color-main, #5A80FB)',
  color: '#FFFFFF',
  '&:hover': { backgroundColor: '#4A6FE8', boxShadow: 'none' },
};

export const secondaryButtonSx = {
  ...base,
  color: '#1A1A2E',
  backgroundColor: '#FFFFFF',
  border: '1px solid #E9EDFA',
  '&:hover': { backgroundColor: '#F5F7FE', borderColor: 'rgba(90, 128, 251, 0.35)' },
};

export const dangerButtonSx = {
  ...base,
  backgroundColor: '#DC2626',
  color: '#FFFFFF',
  '&:hover': { backgroundColor: '#B91C1C', boxShadow: 'none' },
};
